import { render, staticRenderFns } from "./paletteColor.vue?vue&type=template&id=0fc4d525&scoped=true&"
import script from "./paletteColor.vue?vue&type=script&lang=js&"
export * from "./paletteColor.vue?vue&type=script&lang=js&"
import style0 from "./paletteColor.vue?vue&type=style&index=0&id=0fc4d525&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4d525",
  null
  
)

export default component.exports